import React from 'react';
import PropTypes from 'prop-types';
import TextInput from "./";

export default class PostcodeTextInput extends React.Component {
    constructor(props) {
        super(props);
        // the maximum string length for receipt number including 2 slashes
        // e.g. `1/2/1234`
        this.MAX_LENGTH = 4;

        this.state = {
            value: props.value.trim()
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidUpdate(){
        console.log("yes");
    }
    handleChange(event) {
        console.log("p");
       const val = event.target.value;
       const removeFormat = (str) => str.replace(/\D/g, '');
        this.props.onChange({
            target: {
                name: this.props.name,
                value: removeFormat(this.truncate(val)),
                type: 'text',
            }
        });
    }

    truncate(str) {
        return str.substring(0, this.MAX_LENGTH);
    }

    parseValue(val) {
        return val.trim().replace(/\D/g, '');
    }

    render() {
        const { value, onChange, ...otherProps } = this.props;
        const newValue = this.truncate(this.parseValue(value));

        return (
            <TextInput
                {...otherProps}
                value={newValue}
                onChange={this.handleChange}
            />
        );
    } 
}

PostcodeTextInput.propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
    warning: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
};
